<template>
  <div id="lymap"></div>
</template>
<script>
var lineGroups = [];
var markers=[];
var map;
export default {
  props:['lines'],
  data() {
    return {};
  },
  methods: {
    gMap(point) {
      map = new AMap.Map("lymap", {
        resizeEnable: true,
        center: point,
        zoom: 13,
        defaultCursor: "",
      });
    },
    showlines(v) {
      map.remove(lineGroups);
      // lineGroups
      var polyArrs = [];
      var paths = [];
      for (var i = 0; i < v.length; i++) {
        var add = [];
        for (const j in v[i].pointList) {
          var dd = v[i].pointList[j];
          var small = new AMap.LngLat(dd.x, dd.y);
          add.push(small);
        }
        var ddd = [{pointList:[{ x: 11, y: 22 }]}];
        paths.push(add);
        // 创建线实例
        var polyline = new AMap.Polyline({
          path: paths[i],
          borderWeight: 4,
          strokeColor: "blue",
        });
        polyArrs.push(polyline);
      }
      lineGroups = new AMap.OverlayGroup(polyArrs);
      map.add(lineGroups);
      map.setFitView();
    },
    //参考线
    showLine(v){
      this.utils.showLines(map,v)
    },
    //显示垃圾桶
    showLjt(data_info) {
      map.remove(markers);
      markers = [];
      for (var i = 0, marker; i < data_info.length; i++) {
        var icon = new AMap.Icon({
          size: new AMap.Size(24, 24), // 图标尺寸
          image: "static/ljt1.png", // Icon的图像
          imageOffset: new AMap.Pixel(0, 0), // 图像相对展示区域的偏移量，适于雪碧图等
          imageSize: new AMap.Size(24, 24), // 根据所设置的大小拉伸或压缩图片
        });

        // 创建覆盖物群组，并将 marker 传给 OverlayGroup
        marker = new AMap.Marker({
          map: map,
          position: [data_info[i].x, data_info[i].y],
          icon: icon,
          offset: new AMap.Pixel(-12, -12),
          zIndex: 1000,
        });
        marker.setLabel({
          content: "<div>" + data_info[i].name + "</div>",
          offset: new AMap.Pixel(26, 6),
        });

        markers.push(marker);
      }
      map.setFitView();
      //infoWindow.on("close", alert('关闭'));
    }
  },
  mounted() {
    this.gMap();
  },
  watch:{
    lines(v){
      console.log(v);
      this.showlines(v);
    }
  }
};
</script>
<style lang="">
#lymap {
  width: 100%;
  height: 100%;
  background: red;
}
</style>


// WEBPACK FOOTER //
// src/components/map/lyMap.vue